import { EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ArrayFormService } from './array-form.service';
import { NgClass } from '@angular/common';
import { SimpleFieldsetComponent } from '../simple-fieldset/simple-fieldset.component';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import * as i0 from "@angular/core";
const _c0 = a0 => ({
  "invalid-overlay": a0
});
const _c1 = (a0, a1) => [a0, a1];
const _c2 = a0 => ({
  index: a0
});
export let ArrayFieldsetInner = /*#__PURE__*/(() => {
  class ArrayFieldsetInner {
    constructor() {
      this.removeItem = new EventEmitter();
    }
    static {
      this.ɵfac = function ArrayFieldsetInner_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ArrayFieldsetInner)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: ArrayFieldsetInner,
        selectors: [["array-fieldset-inner"]],
        inputs: {
          formService: "formService",
          formGroup: "formGroup",
          Model: "Model",
          instructions: "instructions",
          innerForm: "innerForm",
          index: "index"
        },
        outputs: {
          removeItem: "removeItem"
        },
        features: [i0.ɵɵProvidersFeature([])],
        decls: 3,
        vars: 12,
        consts: [[3, "ngClass"], [3, "controlFormServiceChildProp", "instructions", "innerForm", "innerFormData"], ["uiButton", "", "icon", "trash", "title", "Item L\u00F6schen", 1, "button-remove", "small", "ui-button-outline", 3, "click"]],
        template: function ArrayFieldsetInner_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0)(1, "simple-fieldset", 1);
            i0.ɵɵelementStart(2, "button", 2);
            i0.ɵɵlistener("click", function ArrayFieldsetInner_Template_button_click_2_listener() {
              return ctx.removeItem.emit(ctx.index);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx.formGroup.touched && ctx.formGroup.invalid));
            i0.ɵɵadvance();
            i0.ɵɵproperty("controlFormServiceChildProp", i0.ɵɵpureFunction2(7, _c1, ctx.formService, ctx.index))("instructions", ctx.instructions)("innerForm", ctx.innerForm)("innerFormData", i0.ɵɵpureFunction1(10, _c2, ctx.index));
          }
        },
        dependencies: [NgClass, SimpleFieldsetComponent, UiButtonComponent],
        styles: [".button-remove[_ngcontent-%COMP%]{position:absolute;right:5px;top:5px;background:none;opacity:.5}.button-remove[_ngcontent-%COMP%]:hover{opacity:1}.button-add[_ngcontent-%COMP%]{margin-top:6px}.invalid-overlay[_ngcontent-%COMP%]{position:absolute;inset:0;pointer-events:none;border:2px solid rgba(255,0,0,.3)}.invalid-overlay[_ngcontent-%COMP%] + *[_ngcontent-%COMP%]{position:relative;z-index:1}array-fieldset   [_nghost-%COMP%]   .invalid-overlay[_ngcontent-%COMP%]{border:2px solid rgba(255,0,0,.5)}"],
        changeDetection: 0
      });
    }
  }
  return ArrayFieldsetInner;
})();